import { SlideoutMenu } from "@/components/application/slideout-menus/slideout-menu";
import { useChatAI } from "./chat-ai-context";
import { AIChatWindow } from "./ai-chat-window";
import { ChatHistoryView } from "./chat-history-view";
import { Plus, Clock } from "@untitledui/icons";
import { Button } from "@/components/base/buttons/button";
import { Tooltip } from "@/components/base/tooltip/tooltip";
import { useTranslation } from "react-i18next";

export const AIChatDrawer = () => {
    const { isDrawerOpen, closeDrawer, createNewChat, isHistoryView, toggleHistoryView } = useChatAI();
    const { t } = useTranslation(['common']);

    return (
        <SlideoutMenu
            isOpen={isDrawerOpen}
            onOpenChange={(open) => (!open ? closeDrawer() : undefined)}
            className="ml-auto w-screen md:w-[33vw] max-w-none pl-0 md:pl-0 z-1000"
            dialogClassName="bg-primary_alt ring-secondary_alt shadow-xl w-full pl-0"
        >
            <SlideoutMenu.Content role="dialog" aria-label="AI Chat Drawer" className="flex flex-col h-full p-0">
                <SlideoutMenu.Header onClose={closeDrawer} className="flex-shrink-0">
                    <div className="flex items-center justify-between w-full pr-12 mb-2">
                        <h3 className="text-lg font-medium text-brand-primary">Chat AI</h3>
                        <div className="flex items-center gap-4">
                            <Tooltip title={t('aiChat.newChat')} placement="bottom">
                                <Button
                                    onClick={createNewChat}
                                    color="link-color"
                                    size="sm"
                                    iconLeading={Plus}
                                />
                            </Tooltip>
                            <Tooltip title={t('aiChat.chatHistory')} placement="bottom">
                                <Button
                                    onClick={toggleHistoryView}
                                    color={isHistoryView ? "primary" : "link-color"}
                                    size="sm"
                                    iconLeading={Clock}
                                />
                            </Tooltip>
                        </div>
                    </div>
                    <p className="mt-0.5 text-xs text-tertiary">Conversazione con assistente contestuale</p>
                </SlideoutMenu.Header>
                <div className="flex flex-1 min-h-0 overflow-hidden w-full">
                    {isHistoryView ? (
                        <ChatHistoryView />
                    ) : (
                        <AIChatWindow />
                    )}
                </div>
            </SlideoutMenu.Content>
        </SlideoutMenu>
    );
};


